module.exports = __webpack_public_path__ + "static/img/s07.fdbd9f18.png";